"use client";

import { useTranslations } from "use-intl";

import { ReleaseFormatIcon, ReleaseIcon } from "@/components/appIcons";
import { useFormatNumber } from "@/hooks/use-format-number";
import { ALBUM_TYPES } from "@garimpa/lib/albumTypes";
import { FORMAT_CATEGORIES } from "@garimpa/lib/formatGroups";

import { FacetOptionGrid } from "./facet-option-list";
import {
  ALBUM_TYPE_ICONS,
  FORMAT_CATEGORY_ICONS,
  FORMAT_LABEL_KEYS,
} from "./search-taxonomy-options";

export function SearchDiscoveryCatalogPresets({
  type,
  format,
  updateFilter,
}: {
  type: string | undefined;
  format: string | undefined;
  updateFilter: (key: string, value: string | number | boolean | undefined) => void;
}) {
  const t = useTranslations("globals.search");
  const tt = useTranslations("globals.search.albumType");
  const formatNumber = useFormatNumber();

  return (
    <div className="mb-6 grid items-start gap-4 md:grid-cols-[3fr_2fr]">
      <section className="rounded-2xl border border-border/80 bg-background/70 p-4 transition-colors hover:border-primary/25">
        <h3 className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-muted-foreground">
          <ReleaseIcon className="text-base" /> {t("type")}
        </h3>
        <FacetOptionGrid
          items={ALBUM_TYPES.map((value) => ({
            value,
            label: tt(value),
            icon: ALBUM_TYPE_ICONS[value],
          }))}
          value={type}
          onChange={(value) => updateFilter("type", value)}
          formatCount={formatNumber}
          className="sm:grid-cols-3"
          prominent
        />
      </section>
      <section className="rounded-2xl border border-border/80 bg-background/70 p-4 transition-colors hover:border-primary/25">
        <h3 className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-muted-foreground">
          <ReleaseFormatIcon className="text-base" /> {t("format")}
        </h3>
        <FacetOptionGrid
          items={FORMAT_CATEGORIES.map((value) => ({
            value,
            label: t(FORMAT_LABEL_KEYS[value]),
            icon: FORMAT_CATEGORY_ICONS[value],
          }))}
          value={format}
          onChange={(value) => updateFilter("format", value)}
          formatCount={formatNumber}
          prominent
        />
      </section>
    </div>
  );
}
